import { useTranslation } from "react-i18next";
import { TitleText, TitleContainer, TitleIcon } from "./styles";
import { useBreakpoint } from "hooks/use-breakpoint";

export function WhatsCoveredTitle() {
  const { t } = useTranslation("screens", { keyPrefix: "offer.whatsCovered" });
  const title = t("title");
  const mdBreakpoint = useBreakpoint("md");

  return (
    <TitleContainer>
      {mdBreakpoint && <TitleIcon />}
      <TitleText>{title}</TitleText>
    </TitleContainer>
  );
}
